import { BtnGroupItem } from '@shared/components/btn-group/btn-group.component';
import { TreeListAction } from '@app/orders/models/dx-tree-list.model';

export type TreeListActionContext = 'row' | 'selection';

export interface BuildTreeListActionOverflowItemsParams<TContext> {
  action: TreeListAction;
  context: TContext;
  label: string;
  onAction: () => void;
}

export function getTreeListActionKey(action: TreeListAction): string | null {
  if (action?.dataCy) return `dataCy:${action.dataCy}`;

  const label = action?.label ?? '';
  const icon = action?.icon ?? '';
  const tooltipValue = action?.tooltipValue ?? '';
  const key = `${label}|${icon}|${tooltipValue}`.trim();
  return key === '||' ? null : key;
}

export function buildTreeListActionOverflowItems<TContext>(
  params: BuildTreeListActionOverflowItemsParams<TContext>,
): BtnGroupItem[] {
  const { action, context, label, onAction } = params;
  if (!label) return [];

  if (action?.multiple === true && typeof action.groupItems === 'function') {
    const groupItems = action.groupItems(context) ?? [];
    const headerLabel = groupItems.find((item) => item?.notListed === true && !!item?.label)?.label;
    const children = groupItems.filter((item) => item?.hide !== true && item?.notListed !== true);
    if (!children.length) return [];
    return [{ label: headerLabel ?? label, children }];
  }

  return [{ label, action: onAction }];
}


